import React, { Suspense, lazy , useState} from "react";
import { NavLink, Outlet } from "react-router-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./layout/Dashboard";
import Homme from "./Pages/Homme";
import Gallerry from "./Pages/Gallerry";
import Orderrs from "./Pages/Orderrs";
import Abouttus from "./Pages/Abouttus";
import Enquirry from "./Pages/Enquirry";
import Home from "./Component/Home";
import ImageOne from "./HomeNavs/ImageOne";
import ImageTwo from "./HomeNavs/ImageTwo";
import ImageThree from "./HomeNavs/ImageThree";
import ImageFour from "./HomeNavs/ImageFour";
import ImageFive from "./HomeNavs/ImageFive";
import ImageSix from "./HomeNavs/ImageSix";
import ImageSeven from "./HomeNavs/ImageSeven";
import ImageEight from "./HomeNavs/ImageEight";
import ImageNine from "./HomeNavs/ImageNine";
import ImageTen from "./HomeNavs/ImageTen";
import ImageElevel from "./HomeNavs/ImageElevel";
import ImageTwel from "./HomeNavs/ImageTwel";
import Login from "./Component/Login";
import Signup from "./Component/Signup";
import VarietyShows from "./Component/VarietyShows";
import Varietydetails from "./Component/Varietydetails";
import Varietydetails1 from "./Component/Varietydetails1";
import Varietydetails2 from "./Component/Varietydetails2";
import Varietydetails3 from "./Component/Varietydetails3";
import Varietyshows4 from "./Component/Varietyshows4";
import Varietydetails5 from "./Component/Varietydetails5";
import Varirtydetails6 from "./Component/Varirtydetails6";
import Varietydetails7 from "./Component/Varietydetails7";
import Varietydetails8 from "./Component/Varietydetails8";
import Varietydetails9 from "./Component/Varietydetails9";
import Varietydetails10 from "./Component/Varietydetails10";
import Varietydetails11 from "./Component/Varietydetails11";
// import { useAuth0 } from "@auth0/auth0-react";

const home = lazy(() => import("./Pages/Homme"));
const gallery = lazy(() => import("./Pages/Gallerry"));
const orders = lazy(() => import("./Pages/Orderrs"));
const aboutus = lazy(() => import("./Pages/Abouttus"));
const enquiry = lazy(() => import("./Pages/Enquirry"));
const login = lazy(() => import("./Component/Login"));
const signup = lazy(() => import("./Component/Signup"));
const imageone = lazy(() => import("./HomeNavs/ImageOne"));
const imagetwo = lazy(() => import("./HomeNavs/ImageTwo"));
const imagethree = lazy(() => import("./HomeNavs/ImageThree"));
const imagefour = lazy(() => import("./HomeNavs/ImageFour"));
const imagefive = lazy(() => import("./HomeNavs/ImageFive"));
const imagesix = lazy(() => import("./HomeNavs/ImageSix"));
const imageseven = lazy(() => import("./HomeNavs/ImageSeven"));
const imageeight = lazy(() => import("./HomeNavs/ImageEight"));
const imagenine = lazy(() => import("./HomeNavs/ImageNine"));
const imageten = lazy(() => import("./HomeNavs/ImageTen"));
const imageelvel = lazy(() => import("./HomeNavs/ImageElevel"));
const imagetwel = lazy(() => import("./HomeNavs/ImageTwel"));
const variety = lazy(()=>import("./Component/VarietyShows"));
const varietydetails = lazy(()=>import("./Component/Varietydetails"));
const varietydetails1 = lazy(()=>import("./Component/Varietydetails1"));
const varietydetails2 = lazy(()=>import("./Component/Varietydetails2"));
const varietydetails3 = lazy(()=>import("./Component/Varietydetails3"));
const varietydetails4 = lazy(()=>import("./Component/Varietyshows4"));
const varietydetails5 = lazy(()=>import("./Component/Varietydetails5"));
const varietydetails6 = lazy(()=>import("./Component/Varirtydetails6"));
const varietydetails7 = lazy(()=>import("./Component/Varietydetails7"));
const varietydetails8 = lazy(()=>import("./Component/Varietydetails8"));
const varietydetails9 = lazy(()=>import("./Component/Varietydetails9"));
const varietydetails10 = lazy(()=>import("./Component/Varietydetails10"));
const varietydetails11 = lazy(()=>import("./Component/Varietydetails11"));


const App = () => {
  return (
    <div>
      <BrowserRouter>
        <Suspense>
          <Routes>
            <Route path="/" element={<Dashboard />}>
              <Route path="/" element={<Homme />} />
              <Route path="gallery" element={<Gallerry />} />
              <Route path="orders" element={<Orderrs />} />
              <Route path="aboutus" element={<Abouttus />} />
              <Route path="enquiry" element={<Enquirry />} />
              <Route path="imageone" element={<ImageOne />} />
              <Route path="imagetwo" element={<ImageTwo />} />
              <Route path="imagethree" element={<ImageThree />} />
              <Route path="imagefour" element={<ImageFour />} />
              <Route path="imagefive" element={<ImageFive />} />
              <Route path="imagesix" element={<ImageSix />} />
              <Route path="imageseven" element={<ImageSeven />} />
              <Route path="imageeight" element={<ImageEight />} />
              <Route path="imagenine" element={<ImageNine />} />
              <Route path="imageten" element={<ImageTen />} />
              <Route path="imageelvel" element={<ImageElevel />} />
              <Route path="imagetwel" element={<ImageTwel />} />
              <Route path="login" element={<Login />} />
              <Route path="signup" element={<Signup />} />
              <Route path="variety" element={<VarietyShows/>}/>
              <Route path="varietydetails" element={<Varietydetails/>}/>
              <Route path="varietydetails1" element={<Varietydetails1/>}/>
              <Route path="varietydetails2" element={<Varietydetails2/>}/>
              <Route path="varietydetails3" element={<Varietydetails3/>}/>
              <Route path="varietydetails4" element={<Varietyshows4/>}/>
              <Route path="varietydetails5" element={<Varietydetails5/>}/>
              <Route path="varietydetails6" element={<Varirtydetails6/>}/>
              <Route path="varietydetails7" element={<Varietydetails7/>}/>
              <Route path="varietydetails8" element={<Varietydetails8/>}/>
              <Route path="varietydetails9" element={<Varietydetails9/>}/>
              <Route path="varietydetails10" element={<Varietydetails10/>}/>
              <Route path="varietydetails11" element={<Varietydetails11/>}/>
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
};

export default App;
